import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { toasterMessages } from '@messages/*';
import { CountryISO, PhoneNumberFormat, SearchCountryField } from 'ngx-intl-tel-input';
import { ToastrService } from 'ngx-toastr';
import { DashboardService } from '../dashboard.service';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})

export class ProfileComponent implements OnInit {

  constructor(
    private dashboardService: DashboardService,
    private formBuilder: UntypedFormBuilder,
    private toastr: ToastrService
  ) { }

  get formField() { return this.profileForm.controls; }

  separateDialCode = true;
  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  PhoneNumberFormat = PhoneNumberFormat;
  preferredCountries: CountryISO[] = [CountryISO.UnitedStates, CountryISO.UnitedKingdom];

  profilepic: any;
  profileForm: UntypedFormGroup;

  changePreferredCountries() {
    this.preferredCountries = [CountryISO.India, CountryISO.Canada];
  }

  ngOnInit() {
    this.profileForm = this.formBuilder.group({
      name: ['', Validators.required],
      address: [''],
      email: ['', [Validators.required, Validators.email, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]],
      phone: new UntypedFormControl(undefined, [Validators.required])
    });
    this.getprofile();
  }

  /** get user profile */
  getprofile() {
    this.dashboardService.getUserProfile().subscribe((res: any) => {
      this.profilepic = res?.logo;

      // Handle phone number - new format (separate fields)
      let phoneValue: any = '';

      if (res?.phoneCountryCode && res?.phoneNumber) {
        // Clean the phone number by removing leading 0 and spaces
        const cleanPhoneNumber = res.phoneNumber.replace(/^0+/, '').replace(/\s/g, '');

        phoneValue = {
          dialCode: res.phoneCountryCode.replace('+', ''),
          number: cleanPhoneNumber,
          nationalNumber: cleanPhoneNumber
        };
      }

      this.profileForm.setValue({
        name: res?.name || '',
        address: res?.address || '',
        email: res?.email || '',
        phone: phoneValue
      });
    });
  }

  addpicture() {
    const fileUpload = document.getElementById('fileUpload') as HTMLInputElement;
    fileUpload.onchange = () => {
      for (let i = 0; i < fileUpload.files.length; i++) {
        const profilepic = fileUpload.files[i];
        const reader = new FileReader();
        reader.readAsDataURL(profilepic);
        reader.onload = (event: any) => { // called once readAsDataURL is completed
          this.profilepic = event.target.result;
        };
      }
    };
    fileUpload.click();
  }

  /** Update Profile */
  updateProfile() {
    const formData = new FormData();
    formData.append('profilePic', this.profilepic);
    formData.append('name', this.profileForm.get('name').value);
    formData.append('email', this.profileForm.get('email').value);
    formData.append('address', this.profileForm.get('address').value);

    // Handle phone number object from ngx-intl-tel-input
    const phoneValue = this.profileForm.get('phone').value;
    if (typeof phoneValue === 'object' && phoneValue !== null) {
      // Extract country code and mobile number separately
      if (phoneValue.dialCode) {
        // dialCode already contains the + symbol, so don't add another one
        const countryCode = phoneValue.dialCode.startsWith('+') ? phoneValue.dialCode : '+' + phoneValue.dialCode;
        formData.append('phoneCountryCode', countryCode);
      }
      if (phoneValue.number) {
        // Clean the phone number by removing leading 0 and spaces
        const cleanNumber = phoneValue.number.replace(/^0+/, '').replace(/\s/g, '');
        formData.append('phoneNumber', cleanNumber);
      } else if (phoneValue.nationalNumber) {
        // Clean the phone number by removing leading 0 and spaces
        const cleanNumber = phoneValue.nationalNumber.replace(/^0+/, '').replace(/\s/g, '');
        formData.append('phoneNumber', cleanNumber);
      }
    }

    this.dashboardService.updateUserProfile(formData).subscribe((res: any) => {
      this.toastr.success(toasterMessages.profileUpdatedSuccess);
    }, (err) => {
      this.toastr.error(err?.error?.errors[0]?.error, 'Error');
    });
  }

}
